<template>
  <div class="ticketState">
    <div class="title">门票凭证</div>
    <ul>
      <li
        v-for="(item, index) in itemList"
        :key="item.itemId"
        class="available active"
        :class="{
          'not' : item.ticketStatus == '0' || item.ticketStatus == '1',
          'part' : item.ticketStatus == '3',
          'already' : item.ticketStatus == '4',
          'retreat' : item.ticketStatus == '5'
          }">
        <header @click="clickCurrent(index)">
          <div class="left">
            <span>{{ index + 1 }}</span>
            <span class="ticketName owt1">{{ item.displayName }} * {{ item.playCount }}</span>
            <span>状态: {{ item.ticketStatusName }}</span>
          </div>
          <i></i>
        </header>
        <main>
          <template v-if="item.attrList.length === 1">
            <div @click="assertShowCode(item)" class="identity" v-for="item1 in item.attrList" :key="item1.id" v-if="item1.cerNo">
              <div class="left">
                <i class="remind">必带</i>
                <div>证件</div>
              </div>
              <div class="right" v-watermark="{ text:item1.cerTypeName, textColor:'rgba(241, 242, 247, 0.49)'}">
                <span>{{ item1.name }}</span>
                <span>{{ item1.cerNo }}</span>
              </div>
            </div>
          </template>
          <!-- 票状态 0:待出票 1:未激活 2:未使用 3:部分使用 4:已使用 5:已退票 -->
          <div class="code" :class="{ 'not-bottom': item.attrList.length !== 1 }" v-if="item.mediaType === 'qr_code'">
            <div class="left">
              <div>门票二维码</div>
            </div>
            <!-- 待出票 -->
            <div class="right" v-if="item.ticketStatus == '0'">
              <div>正在为您出票</div>
              <div>请稍等...</div>
            </div>
            <!-- 未激活 -->
            <div class="right" v-if="item.ticketStatus == '1'">
              <div>门票未激活</div>
              <div>请激活后再进行使用</div>
            </div>
            <!-- 未使用 -->
            <div class="right" v-if="item.attrList.length && item.ticketStatus == '2' || item.ticketStatus == '3'">
              <vue-qr :colorDark="item.codeColor" :correctLevel="0" :margin="40" backgroundColor="rgb(255, 255, 255)" :text="item.encTicketNo || item.ticketNo" :size="500"></vue-qr>
            </div>
            <!-- 已使用 -->
            <div class="right" v-if="item.ticketStatus == '4'">
              <vue-qr :colorDark="item.codeColor" :correctLevel="0" :margin="40" backgroundColor="rgb(255, 255, 255)" :text="item.encTicketNo || item.ticketNo" :size="500"></vue-qr>
              <span>{{ item.ticketStatusName }}</span>
            </div>
            <!-- 已退票 -->
            <div class="right" v-if="item.ticketStatus == '5'">
              <vue-qr :colorDark="item.codeColor" :correctLevel="0" :margin="40" backgroundColor="rgb(255, 255, 255)" :text="item.encTicketNo || item.ticketNo" :size="500"></vue-qr>
              <span>{{ item.ticketStatusName }}</span>
            </div>
          </div>
          <!-- 一票多人 -->
          <template v-if="item.attrList.length !== 1 && item.attrList[0].cerNo">
            <div @click="assertShowCode(item)" class="tourist-info">
              <div class="left">
                <div>游客信息</div>
              </div>
              <div class="right">
                <div class="text" v-for="item1 in item.attrList" :key="item1.id">
                  <span>{{ item1.name }}</span>
                  <span>{{ item1.cerNo }}</span>
                </div>
              </div>
            </div>
          </template>
        </main>
      </li>
    </ul>
    <div class="popup-mask" v-if="hideCode">
      <div class="popup">
        <!-- 展示待出票 -->
        <div class="popup-booth-text" v-if="popupTicket.ticketStatus == '0'">
          <div class="popup-booth-text-box">
            <div>正在为您出票</div>
            <div>请稍等...</div>
          </div>
        </div>
        <!-- 未激活 -->
        <div class="popup-booth-text" v-else-if="popupTicket.ticketStatus == '1'">
          <div class="popup-booth-text-box">
            <div>门票未激活</div>
            <div>请激活后再进行使用</div>
          </div>
        </div>
        <!-- 展示二维码 -->
        <div v-else class="popup-img" :class="{ 'popup-not-available': popupTicket.ticketStatus == '4' || popupTicket.ticketStatus == '5' }">
          <vue-qr :colorDark="popupTicket.codeColor" :correctLevel="0" :margin="40" backgroundColor="rgb(255, 255, 255)" :text="popupTicket.encTicketNo || popupTicket.ticketNo" :size="500"></vue-qr>
          <span v-if="popupTicket.ticketStatus == '4' || popupTicket.ticketStatus == '5'">{{ popupTicket.ticketStatusName }}</span>
        </div>
        <div class="popup-close" @click="assertHideCode">关闭</div>
      </div>
    </div>
  </div>
</template>

<script>
import VueQr from 'vue-qr';
export default {
  name: "ticketState",
  props:['itemList'],
  data() {
    return {
      currentIndex:0,
      hideCode: false,
      popupEncTicketNo: '',
      popupTicket: null
    };
  },
  methods: {
    clickCurrent(index) {
      this.currentIndex = index;
    },
    assertHideCode(){
      this.hideCode = false;
      this.$beyondHiding(false);
      this.popupTicket = null;
    },
    assertShowCode(item){
      const mediumList = this.$store.state.oliver;
      const ckeckItem = mediumList.some(({ ticketSn }) => (ticketSn === item.ticketSn && item.openType === "eject"));
      if(!ckeckItem)return;
      this.popupTicket = item;
      this.hideCode = true;
      this.$beyondHiding(true);
    },
  },
  components:{
    VueQr
  },
  watch: {
    // 监听只为实时更新双介质
    itemList(newValue){
      if(!this.popupTicket)return;
      this.popupTicket = newValue.find((v) => v.itemId === this.popupTicket.itemId);
    }
  },
};
</script>

<style scoped lang='less'>
.ticketState {
  padding: 0.533333rem 0.32rem;
  line-height: 1;
  border-top: 1px dashed #A1A6BA;
  .title {
    font-weight: bold;
    font-size: 0.48rem;
  }
  ul {
    margin-top: 0.16rem + 0.106667rem;
    font-size: 0.213333rem * 2;
    color: #ffffff;
    li {
      margin-bottom: 0.133333rem;
    }
    header {
      line-height: 0.48rem * 2;
      background: #C4D1E3;
      padding: 0 0.346667rem 0 0.213333rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-radius: 0.16rem;
      .left {
        font-size: .346667rem;
        flex: 1;
        padding-right: .466667rem;
        white-space: nowrap;
        display: flex;
        span:first-child {
          margin-right: .2rem;
        }
        .ticketName{
          max-width: 12em;
          margin-right: .2rem;
        }
      }
      i {
        width: 0;
        height: 0;
        border: 0.2rem solid;
        border-top-width: 0.2rem;
        border-color: #ffffff transparent transparent transparent;
        transform: translateX(25%) rotate(-90deg);
        flex-shrink: 0;
      }
    }
    main {
      margin-top: 0.053333rem;
      .identity {
        display: flex;
        margin-bottom: 0.053333rem;
        .left {
          width: 1.066667rem;
          color: #fff;
          font-size: 0.48rem;
          line-height: 0.253333rem * 2;
          display: flex;
          flex-direction: column;
          align-items: center;
          padding: 0.08rem + 0.08rem + .4667rem 0 0.08rem + 0.08rem;
          position: relative;
          .remind{
            position: absolute;
            left: 0;
            top: 0;
            background: #B42A2A;
            line-height: .4667rem;
            font-size: .32rem;
            color: #FFFFFF;
            width: 100%;
            text-align: center;
          }
          div {
            width: 0.32rem * 2;
            font-size: 0.48rem;
            line-height: 0.6rem;
            text-align: center;
          }
        }
        .right {
          flex: 1;
          background: #f1f2f7;
          color: #333333;
          display: flex;
          align-items: center;
          justify-content: center;
          span:first-child {
            margin-right: 0.226667rem * 2;
          }
        }
      };

      .tourist-info{
        display: flex;
        margin-top: 0.053333rem;
        border-radius: 0 0 0.16rem 0.16rem;
        overflow: hidden;
        .left {
          width: 1.066667rem;
          color: #fff;
          font-size: 0.48rem;
          line-height: 0.253333rem * 2;
          display: flex;
          flex-direction: column;
          align-items: center;
          padding: 0.08rem + 0.08rem 0;
          div {
            width: 0.32rem * 2;
            font-size: 0.48rem;
            line-height: 0.6rem;
            text-align: center;
          }
        };
        .right{
          background: #f1f2f7;
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          color: #333333;
          .text{
            margin-bottom: .186667rem;
            &:last-child{
              margin-bottom: 0;
            }
            span:first-child {
              margin-right: 0.226667rem * 2;
            }
          }
        }
      };

      .code {
        height: 2.306667rem * 2;
        display: flex;
        border-radius: 0 0 0.16rem 0.16rem;
        overflow: hidden;
        .left {
          background: #C4D1E3;
          width: 1.066667rem;
          display: flex;
          align-items: center;
          justify-content: center;
          div {
            width: 0.32rem * 2;
            font-size: 0.48rem;
            line-height: 0.6rem;
            text-align: center;
          }
        }
        .right {
          flex: 1;
          background: #f1f2f7;
          display: flex;
          align-items: center;
          justify-content: center;
          position: relative;
          img {
            width: 1.973333rem * 2;
            height: 1.973333rem * 2;
          }
          span{
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            color: #BF2424;
            font-size: 1.093333rem;
            font-weight: bold;
          }
        }
      };

      .not-bottom{
        border-radius: 0;
      }

    }
    .active {
      height: auto;
      overflow: visible;
      header {
        border-radius: 0.16rem 0.16rem 0 0 !important;
        background: #C4D1E3;
        i {
          transform: translateY(25%) rotate(0deg);
        }
      }
    }
    .available{
      header {
        background: #C4D1E3;
      }
      main{
        .left{
            background: #C4D1E3;
        }
      }
    }
    .already{
      header{
        background: #A1A6BA;
        em{
          color: #BF2424;
        }
      }
      main{
        .left{
            background: #A1A6BA;
        }
        img{
          opacity: 0.1;
        }
      }
    }
    .part{
      header{
        background: #E9C439;
        em{
          color: #BF2424;
        }
      }
      main{
        .left{
            background: #E9C439;
        }
      }
    }
    .retreat{
      header{
        background: #A1A6BA;
        em{
          color: #BF2424;
        }
      }
      main{
        .left{
            background: #A1A6BA;
        }
        .code{
          .right{
            color: #BF2424;
            font-size: 1.093333rem;
            font-weight: bold;
            img{
              opacity: 0.1;
            }
          }
        }
      }
    }
    .not{
      header{
        background: #333333;
        em{
          color: #BF2424;
        }
      }
      main{
        .left{
            background: rgba(58, 62, 92, .8);
        }
        .code{
          .right{
            color: #333333;
            font-size: .8rem;
            font-weight: bold;
            flex-direction: column;
            line-height: .64rem * 2;
          }
        }
      }
    }

  }
  .popup-mask{
    position: fixed;
    width: 100vw;
    height: 100vh;
    left: 0;
    top: 0;
    background: rgba(0, 0, 0, 0.42);
    z-index: 9999999;
    .popup{
      position: fixed;
      left: 50%;
      top: 45%;
      transform: translate(-50%, -50%);
      width: 100%;
      padding: 0 1.066667rem;
      z-index: 9999999;
      display: flex;
      flex-direction: column;
      .popup-booth-text{
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius:0.16rem 0.16rem 0 0;
        color: #333333;
        font-size: .8rem;
        font-weight: bold;
        flex-direction: column;
        line-height: .64rem * 2;
        background: #f1f2f7;
        .popup-booth-text-box{
          height: 6.666667rem;
          text-align: center;
          justify-content: center;
          display: flex;
          align-items: center;
          flex-direction: column;
        }
      }
      .popup-img{
        margin: 0 auto;
        background: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        flex: 1;
        width: 100%;
        padding: .4rem * 3;
        border-radius:0.16rem 0.16rem 0 0;
        img{
          width: 100%;
          height: 100%;
          display: block;
        }
      }
      .popup-not-available{
        position: relative;
        img{
          opacity: 0.1;
        }
        span{
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          color: #BF2424;
          font-size: 1.093333rem;
          font-weight: bold;
        }
      }
      .popup-close{
        font-size: .48rem;
        color: #fff;
        font-weight: bold;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #3B6D9C;
        line-height:1.4rem;
        border-radius: 0 0 0.16rem 0.16rem;
      }
    }
  }
}
</style>
